import { z } from 'zod';
import { BatteryRemainingListSchema } from '../types/Battery';
import { SafeStringSchema } from '../types/CommonSchemas';

export const NebosvodSchema = z.object({
    oprtnId: SafeStringSchema,
    serNum: SafeStringSchema,
    regIndex: SafeStringSchema,
    isVis: z.boolean()
});

export type NebosvodData = z.infer<typeof NebosvodSchema>;

export const ModemSchema = z.object({
    id: SafeStringSchema,
    imei: SafeStringSchema,
    createTime: z.iso.datetime(),
    firmwareVersion: z.int(),
    isLastFirmware: z.int(),
    upgradable: z.boolean(),
    upgradeUrl: SafeStringSchema,
    isOnline: z.boolean(),
    isFrVis: z.boolean(),
    ognId: SafeStringSchema,
    name: SafeStringSchema,
    version: z.int(),
    nebosvodInfo: NebosvodSchema.nullable(),
    isArm: z.boolean(),
    mode: z.int(),
    batteryRemaining: z.preprocess(
        (val) => (val === null ? [] : val),
        BatteryRemainingListSchema
    ),
    mavType: z.int()
});

export type ModemData = z.infer<typeof ModemSchema>;

export const ModemListSchema = z.array(ModemSchema);

export type ModemDataList = z.infer<typeof ModemListSchema>;

export const StartMessageSchema = z.object({
    imei: SafeStringSchema,
    message: SafeStringSchema,
    time: z.iso.datetime(),
    severity: z.number()
});

export type StartMessageData = z.infer<typeof StartMessageSchema>;

export const StartMessageListSchema = z.array(StartMessageSchema);

export type StartMessageListData = z.infer<typeof StartMessageListSchema>;

export const MultipleModemsSchema = z.object({
    isConfirmEmail: z.boolean(),
    isNebosvodAuth: z.boolean(),
    nebosvodLogin: SafeStringSchema,
    modemsInfo: z.preprocess(
        (val) => (val === null ? [] : val),
        ModemListSchema
    ),
    startMsgs: z.preprocess(
        (val) => (val === null ? [] : val),
        StartMessageListSchema
    )
});

export type MultipleModemsData = z.infer<typeof MultipleModemsSchema>;

export const ModemPositionSchema = z.object({
    lat: z.number(),
    lng: z.number(),
    yaw: z.number(),
    imei: SafeStringSchema,
    isOnline: z.boolean()
});

export type ModemPositionData = z.infer<typeof ModemPositionSchema>;

export const ModemPositionListSchema = z.array(ModemPositionSchema);

export type ModemPositionDataList = z.infer<typeof ModemPositionListSchema>;

export const ModemTypeSchema = z.object({
    imei: SafeStringSchema,
    type: z.int(),
});

export type ModemTypeData = z.infer<typeof ModemTypeSchema>;

export const ModemTypeListSchema = z.array(ModemTypeSchema);

export type ModemTypeDataList = z.infer<typeof ModemTypeListSchema>;

export const SetBaudRateResponseSchema = z.object({
    state: z.enum(["Ok", "ModemNotOnline"])
});

export type SetBaudRateResponseData = z.infer<typeof SetBaudRateResponseSchema>;

export const BindModemResponseSchema = z.object({
    state: z.enum(["Ok", "NotPressedBind", "ModemNotOnline"]),
    bindTime: z.number().optional(),
});

export type BindModemResponseData = z.infer<typeof BindModemResponseSchema>;

export const UploadFirmwareResponseSchema = z.object({
    state: z.enum(["Ok", "NotPressedBind", "ModemNotOnline"]),
});

export type UploadFirmwareResponseData = z.infer<typeof UploadFirmwareResponseSchema>;

export interface DroneBindModemRequestData {
    imei: string;
}

export interface DroneUnbindModemRequestData {
    imei: string;
}

export interface DroneUploadFirmwareRequestData {
    imei: string;
}

export interface DroneSetBaudRateRequestData {
    baudRate: number;
    imei: string;
}
